import React, { useState,useEffect } from "react";
import CtaLayout from "../components/CtaLayout";
import "../styles/common.css";
import "../styles/cta.css";


function CtaWebsite() {

  return (
    <>
      <CtaLayout title="お問い合わせ" lead="CONTACT">
      <div className='cta-box__text'>
        <h3>「仕様決め」のフェーズからご相談ください。</h3>
        <p>LOGOTでは、無料相談を通して、集客戦略から実際のサイト構成、デザイン、機能面などの「仕様部分」からご提案させていただいております。<br/>サイトリニューアルが未確定という方からのお問い合わせも大歓迎ですので、まずはお気軽にご相談くださいませ。</p>
      </div>
    </CtaLayout>
    </>
  );
}

export default CtaWebsite;
